import { useEffect } from 'react';

/**
 * Hook that listens for keyboard events and executes a callback when specified keys are pressed
 * @param keys - Array of key names to listen for (e.g., ['Escape', 'Delete'])
 * @param callback - Function to execute when any of the specified keys are pressed
 * @param enabled - Whether the listener is active (default: true)
 */
export function useKeyDown(keys: string[], callback: (event: KeyboardEvent) => void, enabled: boolean = true) {
    useEffect(() => {
        if (!enabled) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (keys.includes(event.key)) {
                callback(event);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [keys, callback, enabled]);
}
